frappe.ui.form.ControlCurrency = class ControlCurrency extends frappe.ui.form.ControlFloat {
	get_precision() {
		// always round based on field precision or currency's precision
		// this method is also called in this.parse()
		if (typeof this.df.precision != "number" && !this.df.precision) {
			var currency_precision =
				frappe.boot &&
				frappe.boot.sysdefaults &&
				frappe.boot.sysdefaults.currency_precision;
			if (
				currency_precision !== null &&
				currency_precision !== undefined &&
				currency_precision !== ""
			) {
				// @dokos
				this.df.precision = cint(currency_precision);
			} else {
				var float_precision =
					frappe.boot &&
					frappe.boot.sysdefaults &&
					frappe.boot.sysdefaults.float_precision;
				if (
					float_precision !== null &&
					float_precision !== undefined &&
					float_precision !== ""
				) {
					// @dokos
					this.df.precision = cint(float_precision);
				} else {
					this.df.precision = get_number_format_info(this.get_number_format()).precision;
				}
			}
		}
		return this.df.precision;
	}

	get_number_format() {
		const currency = frappe.meta.get_field_currency(this.df, this.get_doc());
		return get_number_format(currency);
	}
};
